module.exports = __webpack_public_path__ + "static/media/grid1.8c943124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/grid1.jpg
// module id = 879
// module chunks = 0